import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FocusVisibleColoredSurface from './FocusVisibleColoredSurface';
import ClientProvider from './client';
export default createDemo(import.meta.url, FocusVisibleColoredSurface, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/focus-visible/demos/colored-surface/FocusVisibleColoredSurface.tsx",
    "fileName": "FocusVisibleColoredSurface.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport Alert from '@mui/material/Alert';\nimport SnackbarContent from '@mui/material/SnackbarContent';\nimport Button from '@mui/material/Button';\nimport IconButton from '@mui/material/IconButton';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport AddIcon from '@mui/icons-material/Add';\nimport CloseIcon from '@mui/icons-material/Close';\n\nconst theme = createTheme({\n  focusVisible: true,\n  colorSchemes: { light: true, dark: true },\n  // These demos opt out of the ripple, so the focus ring is the only keyboard indicator.\n  components: { MuiButtonBase: { defaultProps: { disableRipple: true } } },\n});\n\nexport default function FocusVisibleColoredSurface() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Stack spacing={3} sx={{ alignItems: 'center' }}>\n        <Typography\n          variant=\"body2\"\n          color=\"text.secondary\"\n          sx={{ alignSelf: 'center' }}\n        >\n          Press <kbd>Tab</kbd> — a background-colored box-shadow renders behind the\n          outline so the ring stays visible on the colored surface.\n        </Typography>\n        <AppBar position=\"static\" sx={{ borderRadius: 1 }}>\n          <Toolbar>\n            <IconButton\n              edge=\"start\"\n              color=\"inherit\"\n              aria-label=\"menu\"\n              sx={{ mr: 2 }}\n            >\n              <MenuIcon />\n            </IconButton>\n            <Typography variant=\"h6\" component=\"div\" sx={{ flexGrow: 1 }}>\n              Title\n            </Typography>\n            <Button color=\"inherit\">Login</Button>\n            <IconButton color=\"inherit\" aria-label=\"add\">\n              <AddIcon />\n            </IconButton>\n          </Toolbar>\n        </AppBar>\n        <Alert\n          variant=\"filled\"\n          severity=\"error\"\n          action={\n            <React.Fragment>\n              <Button color=\"inherit\" size=\"small\">\n                UNDO\n              </Button>\n              <IconButton color=\"inherit\" size=\"small\" aria-label=\"close\">\n                <CloseIcon fontSize=\"inherit\" />\n              </IconButton>\n            </React.Fragment>\n          }\n        >\n          Something went wrong\n        </Alert>\n        <SnackbarContent\n          message=\"Message sent\"\n          action={\n            <Button color=\"inherit\" size=\"small\">\n              UNDO\n            </Button>\n          }\n        />\n      </Stack>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 80,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport Alert from '@mui/material/Alert';\nimport SnackbarContent from '@mui/material/SnackbarContent';\nimport Button from '@mui/material/Button';\nimport IconButton from '@mui/material/IconButton';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport AddIcon from '@mui/icons-material/Add';\nimport CloseIcon from '@mui/icons-material/Close';\n\nconst theme = createTheme({\n  focusVisible: true,\n  colorSchemes: { light: true, dark: true },\n  // These demos opt out of the ripple, so the focus ring is the only keyboard indicator.\n  components: { MuiButtonBase: { defaultProps: { disableRipple: true } } },\n});\n\nexport default function FocusVisibleColoredSurface() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <Stack spacing={3} sx={{ alignItems: 'center' }}>\n        <Typography\n          variant=\"body2\"\n          color=\"text.secondary\"\n          sx={{ alignSelf: 'center' }}\n        >\n          Press <kbd>Tab</kbd> — a background-colored box-shadow renders behind the\n          outline so the ring stays visible on the colored surface.\n        </Typography>\n        <AppBar position=\"static\" sx={{ borderRadius: 1 }}>\n          <Toolbar>\n            <IconButton\n              edge=\"start\"\n              color=\"inherit\"\n              aria-label=\"menu\"\n              sx={{ mr: 2 }}\n            >\n              <MenuIcon />\n            </IconButton>\n            <Typography variant=\"h6\" component=\"div\" sx={{ flexGrow: 1 }}>\n              Title\n            </Typography>\n            <Button color=\"inherit\">Login</Button>\n            <IconButton color=\"inherit\" aria-label=\"add\">\n              <AddIcon />\n            </IconButton>\n          </Toolbar>\n        </AppBar>\n        <Alert\n          variant=\"filled\"\n          severity=\"error\"\n          action={\n            <React.Fragment>\n              <Button color=\"inherit\" size=\"small\">\n                UNDO\n              </Button>\n              <IconButton color=\"inherit\" size=\"small\" aria-label=\"close\">\n                <CloseIcon fontSize=\"inherit\" />\n              </IconButton>\n            </React.Fragment>\n          }\n        >\n          Something went wrong\n        </Alert>\n        <SnackbarContent\n          message=\"Message sent\"\n          action={\n            <Button color=\"inherit\" size=\"small\">\n              UNDO\n            </Button>\n          }\n        />\n      </Stack>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 80,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Stack",
      "@mui/material/AppBar",
      "@mui/material/Toolbar",
      "@mui/material/Typography",
      "@mui/material/Alert",
      "@mui/material/SnackbarContent",
      "@mui/material/Button",
      "@mui/material/IconButton",
      "@mui/icons-material/Menu",
      "@mui/icons-material/Add",
      "@mui/icons-material/Close"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
